// Types for agent data structure
export interface AgentCreator {
	canonicalAccountId: string;
	accountId: string;
	accountStatus: string;
	name: string;
	id: string;
}

export interface AgentNode {
	id: string;
	identityAccountId: string;
	name: string;
	description: string;
	creatorType: string;
	externalConfigReference: string | null;
	instructions: string;
	conversationStarters: string[];
	creator: AgentCreator;
}

export interface AgentEdge {
	node: AgentNode;
}

export interface AgentStudioGetAgentsResponse {
	agentStudio_getAgents: {
		edges: AgentEdge[];
	};
}

export const KNOWLEDGE_CARD_AGENT_SEARCH_OPERATION_NAME = 'KnowledgeCardAgentSearchQuery';
export const KnowledgeCardAgentSearchQuery: '\nquery KnowledgeCardAgentSearchQuery($cloudId: String!, $input: AgentStudioAgentQueryInput!, $limit: Int!) {\n    agentStudio_getAgents(cloudId: $cloudId, input: $input, first: $limit) \n    @optIn(to: "AgentStudio")\n    {\n      edges {\n        node {\n          id\n          identityAccountId\n          name\n          description\n          creator {\n            canonicalAccountId\n            accountId\n            accountStatus\n            id\n            name\n          }\n          creatorType\n          externalConfigReference\n          instructions\n          conversationStarters\n        }\n      }\n    }\n  }' = `
query ${KNOWLEDGE_CARD_AGENT_SEARCH_OPERATION_NAME}($cloudId: String!, $input: AgentStudioAgentQueryInput!, $limit: Int!) {
    agentStudio_getAgents(cloudId: $cloudId, input: $input, first: $limit) 
    @optIn(to: "AgentStudio")
    {
      edges {
        node {
          id
          identityAccountId
          name
          description
          creator {
            canonicalAccountId
            accountId
            accountStatus
            id
            name
          }
          creatorType
          externalConfigReference
          instructions
          conversationStarters
        }
      }
    }
  }`;
